import React from 'react'
import './SubscriptionSnippet.css'

const SubscriptionSnippetUI = ({context, productName}) =>
  <div className='c_sub_snp'>
    <label>{productName}</label>
    <div className="icon icon-caret-right"></div>
  </div>

export default SubscriptionSnippetUI
